export default "__VITE_ASSET__D5cYbe8M__"